// extracted by mini-css-extract-plugin
export default {"root":"IconShoppingBag_root__koaF6"};